/**
 * "Enhance an animatic?" — owner batch 5, T3
 * (docs/superpowers/specs/2026-09-03-owner-batch-5-design.md §T3).
 *
 * A GLOBAL mount, driven purely by animaticEnhanceConfirmStore, so both Enhance hosts — the board's
 * BoardEnhanceDialog and the Timeline AI workspace's WorkspaceMain — get the confirm without either
 * one growing a dialog of its own. Same host pattern as AnimaticRegenDialog; see App.tsx for the
 * three mount sites and why there are three.
 *
 * Every exit routes through `resolvePending`, backdrop and Escape included (SurfaceConfirm's own
 * keydown calls onDismiss), so the awaiting `handleEnhance` can never be left hanging.
 */
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { SurfaceConfirm } from '@/components/SettingsSurface';
import { useAnimaticEnhanceConfirmStore } from '@/store/animaticEnhanceConfirmStore.ts';
import styles from './AnimaticEnhanceConfirmDialog.module.css';

export function AnimaticEnhanceConfirmDialog() {
  const { t } = useTranslation('aiWorkspace');
  const pending = useAnimaticEnhanceConfirmStore((s) => s.pending);
  const resolvePending = useAnimaticEnhanceConfirmStore((s) => s.resolvePending);

  const onDecline = useCallback(() => resolvePending(false), [resolvePending]);
  const onAccept = useCallback(() => resolvePending(true), [resolvePending]);

  if (!pending) return null;

  return (
    <SurfaceConfirm
      ariaLabel={t('animaticEnhanceTitle')}
      testId="animaticEnhanceConfirm"
      onDismiss={onDecline}
      title={t('animaticEnhanceTitle')}
      footer={(
        <>
          <button type="button" className={styles.cancelBtn} onClick={onDecline} autoFocus>
            {t('cancel')}
          </button>
          <button type="button" className={styles.confirmBtn} onClick={onAccept}>
            {t('animaticEnhanceConfirm')}
          </button>
        </>
      )}
    >
      <p className={styles.body}>{t('animaticEnhanceBody', { count: pending.count })}</p>
    </SurfaceConfirm>
  );
}
